import { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input, Label, FormGroup, Button, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import useObtenerClienteById from '../Hooks/useObtenerClienteById';

const ModalLeerCliente = ({ isOpen, toggle, selectedCliente }) => {
    const [activeTab, setActiveTab] = useState('1');
    const [clienteData, setClienteData] = useState({
        CLIPRO: '',
        TPERSO: '',
        RAZSOC: '',
        APENOM: '',
        APEPAT: '',
        APEMAT: '',
        NOMNOM: '',
        COPAIS: '',
        CODCIU: '',
        CIUDAD: '',
        CODCOM: '',
        COMUNA: '',
        DIRECC: '',
        ELGIRO: '',
        CEMAIL: '',
        CONTAC: '',
        NFONO1: '',
        NFONO2: '',
        NFONO3: '',
        ZIPCOD: '',
        ELSEXO: '',
        SINNAC: false,
        FECNAC: '',
        TIPPRO: '',
        NOMPAG: '',
        TIPPAG: '',
        FORPAG: '',
        NROCTA: '',
        BANCTA: '',
        SUCCTA: '',
        CODSUC: '',
        NOMRET: '',
        RUTRET: '',
        TIPCLI: '',
        SININT: false,
        FLUPRO: '',
        FLUCLI: '',
        PAGCON: '',
        PAGDIA: '',
        PAGFON: '',
        PAGMAI: '',
        AUTDVE: false,
        USUDVE: '',
        FECADV: '',
        BLOLCH: false,
        USUBLH: '',
        FECBLH: '',
        CALLES: '',
        NROCAS: '',
        NRODEP: '',
        NROBLO: '',
        SECPOB: '',
        PORDES: '',
        PORSER: '',
        PORREN: '',
        PORRE1: '',
        PORRE2: '',
        SINODC: false,
        LISPRE: '',
        SINEMAIL: false,
        SINFECHA: false,
        CUPO_CREDITO: '',
        SALDO_CREDITO: '',
        UTILIZADO_CREDITO: '',
        ESTADO_CREDITO: '',
        IDSUCURSAL: '',
        RECARGO_FLAG: false,
        RECARGO_MONTO: '',
        FLAG_SIGA: '',
        FLAG_EXT: '',
        USUCRE: '',
        FECCRE: '',
        USUACT: '',
        FECACT: '',
        ULTIMA_ACTUALIZACION: ''
    });

    const { cliente, loading: loadingCliente } = useObtenerClienteById(isOpen ? selectedCliente : null);

    useEffect(() => {
        if (cliente) {
            setClienteData({
                CLIPRO: cliente.CLIPRO || '',
                TPERSO: cliente.TPERSO || '',
                RAZSOC: cliente.RAZSOC || '',
                APENOM: cliente.APENOM || '',
                APEPAT: cliente.APEPAT || '',
                APEMAT: cliente.APEMAT || '',
                NOMNOM: cliente.NOMNOM || '',
                COPAIS: cliente.COPAIS || '',
                CODCIU: cliente.CODCIU || '',
                CIUDAD: cliente.CIUDAD || '',
                CODCOM: cliente.CODCOM || '',
                COMUNA: cliente.COMUNA || '',
                DIRECC: cliente.DIRECC || '',
                ELGIRO: cliente.ELGIRO || '',
                CEMAIL: cliente.CEMAIL || '',
                CONTAC: cliente.CONTAC || '',
                NFONO1: cliente.NFONO1 || '',
                NFONO2: cliente.NFONO2 || '',
                NFONO3: cliente.NFONO3 || '',
                ZIPCOD: cliente.ZIPCOD || '',
                ELSEXO: cliente.ELSEXO || '',
                SINNAC: cliente.SINNAC || false,
                FECNAC: cliente.FECNAC || '',
                TIPPRO: cliente.TIPPRO || '',
                NOMPAG: cliente.NOMPAG || '',
                TIPPAG: cliente.TIPPAG || '',
                FORPAG: cliente.FORPAG || '',
                NROCTA: cliente.NROCTA || '',
                BANCTA: cliente.BANCTA || '',
                SUCCTA: cliente.SUCCTA || '',
                CODSUC: cliente.CODSUC || '',
                NOMRET: cliente.NOMRET || '',
                RUTRET: cliente.RUTRET || '',
                TIPCLI: cliente.TIPCLI || '',
                SININT: cliente.SININT || false,
                FLUPRO: cliente.FLUPRO || '',
                FLUCLI: cliente.FLUCLI || '',
                PAGCON: cliente.PAGCON || '',
                PAGDIA: cliente.PAGDIA || '',
                PAGFON: cliente.PAGFON || '',
                PAGMAI: cliente.PAGMAI || '',
                AUTDVE: cliente.AUTDVE || false,
                USUDVE: cliente.USUDVE || '',
                FECADV: cliente.FECADV || '',
                BLOLCH: cliente.BLOLCH || false,
                USUBLH: cliente.USUBLH || '',
                FECBLH: cliente.FECBLH || '',
                CALLES: cliente.CALLES || '',
                NROCAS: cliente.NROCAS || '',
                NRODEP: cliente.NRODEP || '',
                NROBLO: cliente.NROBLO || '',
                SECPOB: cliente.SECPOB || '',
                PORDES: cliente.PORDES || '',
                PORSER: cliente.PORSER || '',
                PORREN: cliente.PORREN || '',
                PORRE1: cliente.PORRE1 || '',
                PORRE2: cliente.PORRE2 || '',
                SINODC: cliente.SINODC || false,
                LISPRE: cliente.LISPRE || '',
                SINEMAIL: cliente.SINEMAIL || false,
                SINFECHA: cliente.SINFECHA || false,
                CUPO_CREDITO: cliente.CUPO_CREDITO || '',
                SALDO_CREDITO: cliente.SALDO_CREDITO || '',
                UTILIZADO_CREDITO: cliente.UTILIZADO_CREDITO || '',
                ESTADO_CREDITO: cliente.ESTADO_CREDITO || '',
                IDSUCURSAL: cliente.IDSUCURSAL || '',
                RECARGO_FLAG: cliente.RECARGO_FLAG || false,
                RECARGO_MONTO: cliente.RECARGO_MONTO || '',
                FLAG_SIGA: cliente.FLAG_SIGA || '',
                FLAG_EXT: cliente.FLAG_EXT || '',
                USUCRE: cliente.USUCRE || '',
                FECCRE: cliente.FECCRE || '',
                USUACT: cliente.USUACT || '',
                FECACT: cliente.FECACT || '',
                ULTIMA_ACTUALIZACION: cliente.ULTIMA_ACTUALIZACION || ''
            });
        }
    }, [cliente]);



    const handleCancel = () => {
        setClienteData({
            CLIPRO: '',
            TPERSO: '',
            RAZSOC: '',
            APENOM: '',
            APEPAT: '',
            APEMAT: '',
            NOMNOM: '',
            COPAIS: '',
            CODCIU: '',
            CIUDAD: '',
            CODCOM: '',
            COMUNA: '',
            DIRECC: '',
            ELGIRO: '',
            CEMAIL: '',
            CONTAC: '',
            NFONO1: '',
            NFONO2: '',
            NFONO3: '',
            ZIPCOD: '',
            ELSEXO: '',
            SINNAC: false,
            FECNAC: '',
            TIPPRO: '',
            NOMPAG: '',
            TIPPAG: '',
            FORPAG: '',
            NROCTA: '',
            BANCTA: '',
            SUCCTA: '',
            CODSUC: '',
            NOMRET: '',
            RUTRET: '',
            TIPCLI: '',
            SININT: false,
            FLUPRO: '',
            FLUCLI: '',
            PAGCON: '',
            PAGDIA: '',
            PAGFON: '',
            PAGMAI: '',
            AUTDVE: false,
            USUDVE: '',
            FECADV: '',
            BLOLCH: false,
            USUBLH: '',
            FECBLH: '',
            CALLES: '',
            NROCAS: '',
            NRODEP: '',
            NROBLO: '',
            SECPOB: '',
            PORDES: '',
            PORSER: '',
            PORREN: '',
            PORRE1: '',
            PORRE2: '',
            SINODC: false,
            LISPRE: '',
            SINEMAIL: false,
            SINFECHA: false,
            CUPO_CREDITO: '',
            SALDO_CREDITO: '',
            UTILIZADO_CREDITO: '',
            ESTADO_CREDITO: '',
            IDSUCURSAL: '',
            RECARGO_FLAG: false,
            RECARGO_MONTO: '',
            FLAG_SIGA: '',
            FLAG_EXT: '',
            USUCRE: '',
            FECCRE: '',
            USUACT: '',
            FECACT: '',
            ULTIMA_ACTUALIZACION: ''
        });
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} size="lg">
            <ModalHeader toggle={handleCancel}>
                <i className="ri-eye-line me-2"></i>
                Ver Cliente
            </ModalHeader>
            <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {loadingCliente ? (
                    <div className="text-center">Cargando datos del cliente...</div>
                ) : (
                    <>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={activeTab === '1' ? 'active' : ''}
                                    onClick={() => setActiveTab('1')}
                                >
                                    Información Básica
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeTab === '2' ? 'active' : ''}
                                    onClick={() => setActiveTab('2')}
                                >
                                    Datos Personales
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeTab === '3' ? 'active' : ''}
                                    onClick={() => setActiveTab('3')}
                                >
                                    Contacto
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeTab === '4' ? 'active' : ''}
                                    onClick={() => setActiveTab('4')}
                                >
                                    Dirección
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeTab === '5' ? 'active' : ''}
                                    onClick={() => setActiveTab('5')}
                                >
                                    Negocio
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeTab === '6' ? 'active' : ''}
                                    onClick={() => setActiveTab('6')}
                                >
                                    Financiero
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeTab === '7' ? 'active' : ''}
                                    onClick={() => setActiveTab('7')}
                                >
                                    Sistema
                                </NavLink>
                            </NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <div className="row mt-3">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="CLIPRO">RUT *</Label>
                                            <Input
                                                type="text"
                                                id="CLIPRO"
                                                name="CLIPRO"
                                                value={clienteData.CLIPRO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="TPERSO">Tipo de Persona</Label>
                                            <Input
                                                type="text"
                                                id="TPERSO"
                                                name="TPERSO"
                                                value={clienteData.TPERSO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="RAZSOC">Razón Social</Label>
                                            <Input
                                                type="text"
                                                id="RAZSOC"
                                                name="RAZSOC"
                                                value={clienteData.RAZSOC}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="APENOM">Nombre Completo</Label>
                                            <Input
                                                type="text"
                                                id="APENOM"
                                                name="APENOM"
                                                value={clienteData.APENOM}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                            </TabPane>

                            <TabPane tabId="2">
                                <div className="row mt-3">
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label for="APEPAT">Apellido Paterno</Label>
                                            <Input
                                                type="text"
                                                id="APEPAT"
                                                name="APEPAT"
                                                value={clienteData.APEPAT}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label for="APEMAT">Apellido Materno</Label>
                                            <Input
                                                type="text"
                                                id="APEMAT"
                                                name="APEMAT"
                                                value={clienteData.APEMAT}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label for="NOMNOM">Nombres</Label>
                                            <Input
                                                type="text"
                                                id="NOMNOM"
                                                name="NOMNOM"
                                                value={clienteData.NOMNOM}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label for="ELSEXO">Sexo</Label>
                                            <Input
                                                type="text"
                                                id="ELSEXO"
                                                name="ELSEXO"
                                                value={clienteData.ELSEXO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-4">
                                        <FormGroup check>
                                            <Label check>
                                                <Input
                                                    type="checkbox"
                                                    id="SINNAC"
                                                    name="SINNAC"
                                                    checked={clienteData.SINNAC}
                                                    readOnly
                                                />
                                                Sin Fecha de Nacimiento
                                            </Label>
                                        </FormGroup>
                                    </div>
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label for="FECNAC">Fecha de Nacimiento</Label>
                                            <Input
                                                type="date"
                                                id="FECNAC"
                                                name="FECNAC"
                                                value={clienteData.FECNAC}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                            </TabPane>

                            <TabPane tabId="3">
                                <div className="row mt-3">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="CEMAIL">Correo Electrónico</Label>
                                            <Input
                                                type="email"
                                                id="CEMAIL"
                                                name="CEMAIL"
                                                value={clienteData.CEMAIL}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="CONTAC">Persona de Contacto</Label>
                                            <Input
                                                type="text"
                                                id="CONTAC"
                                                name="CONTAC"
                                                value={clienteData.CONTAC}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label for="NFONO1">Teléfono 1</Label>
                                            <Input
                                                type="tel"
                                                id="NFONO1"
                                                name="NFONO1"
                                                value={clienteData.NFONO1}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label for="NFONO2">Teléfono 2</Label>
                                            <Input
                                                type="tel"
                                                id="NFONO2"
                                                name="NFONO2"
                                                value={clienteData.NFONO2}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label for="NFONO3">Teléfono 3</Label>
                                            <Input
                                                type="tel"
                                                id="NFONO3"
                                                name="NFONO3"
                                                value={clienteData.NFONO3}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                            </TabPane>

                            <TabPane tabId="4">
                                <div className="row mt-3">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="COPAIS">Código País</Label>
                                            <Input
                                                type="text"
                                                id="COPAIS"
                                                name="COPAIS"
                                                value={clienteData.COPAIS}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="CODCIU">Código Ciudad</Label>
                                            <Input
                                                type="text"
                                                id="CODCIU"
                                                name="CODCIU"
                                                value={clienteData.CODCIU}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="CIUDAD">Ciudad</Label>
                                            <Input
                                                type="text"
                                                id="CIUDAD"
                                                name="CIUDAD"
                                                value={clienteData.CIUDAD}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="CODCOM">Código Comuna</Label>
                                            <Input
                                                type="text"
                                                id="CODCOM"
                                                name="CODCOM"
                                                value={clienteData.CODCOM}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="COMUNA">Comuna</Label>
                                            <Input
                                                type="text"
                                                id="COMUNA"
                                                name="COMUNA"
                                                value={clienteData.COMUNA}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="ZIPCOD">Código Postal</Label>
                                            <Input
                                                type="text"
                                                id="ZIPCOD"
                                                name="ZIPCOD"
                                                value={clienteData.ZIPCOD}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <FormGroup>
                                            <Label for="DIRECC">Dirección Completa</Label>
                                            <Input
                                                type="text"
                                                id="DIRECC"
                                                name="DIRECC"
                                                value={clienteData.DIRECC}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-3">
                                        <FormGroup>
                                            <Label for="CALLES">Calle</Label>
                                            <Input
                                                type="text"
                                                id="CALLES"
                                                name="CALLES"
                                                value={clienteData.CALLES}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-3">
                                        <FormGroup>
                                            <Label for="NROCAS">N° Casa</Label>
                                            <Input
                                                type="text"
                                                id="NROCAS"
                                                name="NROCAS"
                                                value={clienteData.NROCAS}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-3">
                                        <FormGroup>
                                            <Label for="NRODEP">N° Depto</Label>
                                            <Input
                                                type="text"
                                                id="NRODEP"
                                                name="NRODEP"
                                                value={clienteData.NRODEP}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-3">
                                        <FormGroup>
                                            <Label for="NROBLO">N° Block</Label>
                                            <Input
                                                type="text"
                                                id="NROBLO"
                                                name="NROBLO"
                                                value={clienteData.NROBLO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <FormGroup>
                                            <Label for="SECPOB">Sector/Población</Label>
                                            <Input
                                                type="text"
                                                id="SECPOB"
                                                name="SECPOB"
                                                value={clienteData.SECPOB}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                            </TabPane>

                            <TabPane tabId="5">
                                <div className="row mt-3">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="ELGIRO">Giro</Label>
                                            <Input
                                                type="text"
                                                id="ELGIRO"
                                                name="ELGIRO"
                                                value={clienteData.ELGIRO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="TIPPRO">Tipo de Proveedor</Label>
                                            <Input
                                                type="text"
                                                id="TIPPRO"
                                                name="TIPPRO"
                                                value={clienteData.TIPPRO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="NOMPAG">Nombre para Cheques</Label>
                                            <Input
                                                type="text"
                                                id="NOMPAG"
                                                name="NOMPAG"
                                                value={clienteData.NOMPAG}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="TIPCLI">Tipo de Cliente</Label>
                                            <Input
                                                type="text"
                                                id="TIPCLI"
                                                name="TIPCLI"
                                                value={clienteData.TIPCLI}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="FLUPRO">Flujo Proveedor</Label>
                                            <Input
                                                type="text"
                                                id="FLUPRO"
                                                name="FLUPRO"
                                                value={clienteData.FLUPRO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="FLUCLI">Flujo Cliente</Label>
                                            <Input
                                                type="text"
                                                id="FLUCLI"
                                                name="FLUCLI"
                                                value={clienteData.FLUCLI}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                            </TabPane>

                            <TabPane tabId="6">
                                <div className="row mt-3">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="TIPPAG">Tipo de Pago</Label>
                                            <Input
                                                type="text"
                                                id="TIPPAG"
                                                name="TIPPAG"
                                                value={clienteData.TIPPAG}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="FORPAG">Forma de Pago</Label>
                                            <Input
                                                type="text"
                                                id="FORPAG"
                                                name="FORPAG"
                                                value={clienteData.FORPAG}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="NROCTA">Número de Cuenta</Label>
                                            <Input
                                                type="text"
                                                id="NROCTA"
                                                name="NROCTA"
                                                value={clienteData.NROCTA}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="BANCTA">Banco</Label>
                                            <Input
                                                type="text"
                                                id="BANCTA"
                                                name="BANCTA"
                                                value={clienteData.BANCTA}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="SUCCTA">Sucursal</Label>
                                            <Input
                                                type="text"
                                                id="SUCCTA"
                                                name="SUCCTA"
                                                value={clienteData.SUCCTA}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="CODSUC">Código Sucursal</Label>
                                            <Input
                                                type="text"
                                                id="CODSUC"
                                                name="CODSUC"
                                                value={clienteData.CODSUC}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="CUPO_CREDITO">Cupo de Crédito</Label>
                                            <Input
                                                type="number"
                                                id="CUPO_CREDITO"
                                                name="CUPO_CREDITO"
                                                value={clienteData.CUPO_CREDITO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="SALDO_CREDITO">Saldo de Crédito</Label>
                                            <Input
                                                type="number"
                                                id="SALDO_CREDITO"
                                                name="SALDO_CREDITO"
                                                value={clienteData.SALDO_CREDITO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="UTILIZADO_CREDITO">Crédito Utilizado</Label>
                                            <Input
                                                type="number"
                                                id="UTILIZADO_CREDITO"
                                                name="UTILIZADO_CREDITO"
                                                value={clienteData.UTILIZADO_CREDITO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="ESTADO_CREDITO">Estado Crédito</Label>
                                            <Input
                                                type="text"
                                                id="ESTADO_CREDITO"
                                                name="ESTADO_CREDITO"
                                                value={clienteData.ESTADO_CREDITO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup check>
                                            <Label check>
                                                <Input
                                                    type="checkbox"
                                                    id="SININT"
                                                    name="SININT"
                                                    checked={clienteData.SININT}
                                                    readOnly
                                                />
                                                Sin Cálculo de Intereses
                                            </Label>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup check>
                                            <Label check>
                                                <Input
                                                    type="checkbox"
                                                    id="RECARGO_FLAG"
                                                    name="RECARGO_FLAG"
                                                    checked={clienteData.RECARGO_FLAG}
                                                    readOnly
                                                />
                                                Indicador de Recargo
                                            </Label>
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="RECARGO_MONTO">Monto de Recargo</Label>
                                            <Input
                                                type="number"
                                                id="RECARGO_MONTO"
                                                name="RECARGO_MONTO"
                                                value={clienteData.RECARGO_MONTO}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="LISPRE">Lista de Precios</Label>
                                            <Input
                                                type="number"
                                                id="LISPRE"
                                                name="LISPRE"
                                                value={clienteData.LISPRE}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-3">
                                        <FormGroup>
                                            <Label for="PORDES">% Desc. Productos</Label>
                                            <Input
                                                type="number"
                                                step="0.01"
                                                id="PORDES"
                                                name="PORDES"
                                                value={clienteData.PORDES}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-3">
                                        <FormGroup>
                                            <Label for="PORSER">% Desc. Servicios</Label>
                                            <Input
                                                type="number"
                                                step="0.01"
                                                id="PORSER"
                                                name="PORSER"
                                                value={clienteData.PORSER}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-3">
                                        <FormGroup>
                                            <Label for="PORREN">% Desc. Rentacar</Label>
                                            <Input
                                                type="number"
                                                step="0.01"
                                                id="PORREN"
                                                name="PORREN"
                                                value={clienteData.PORREN}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-3">
                                        <FormGroup>
                                            <Label for="PORRE1">% Rec. Productos</Label>
                                            <Input
                                                type="number"
                                                step="0.01"
                                                id="PORRE1"
                                                name="PORRE1"
                                                value={clienteData.PORRE1}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="PORRE2">% Rec. Servicios</Label>
                                            <Input
                                                type="number"
                                                step="0.01"
                                                id="PORRE2"
                                                name="PORRE2"
                                                value={clienteData.PORRE2}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup check>
                                            <Label check>
                                                <Input
                                                    type="checkbox"
                                                    id="SINODC"
                                                    name="SINODC"
                                                    checked={clienteData.SINODC}
                                                    readOnly
                                                />
                                                Compras sin Orden de Compra
                                            </Label>
                                        </FormGroup>
                                    </div>
                                </div>
                            </TabPane>

                            <TabPane tabId="7">
                                <div className="row mt-3">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="NOMRET">Nombre Retira Documentos</Label>
                                            <Input
                                                type="text"
                                                id="NOMRET"
                                                name="NOMRET"
                                                value={clienteData.NOMRET}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="RUTRET">RUT Retira Documentos</Label>
                                            <Input
                                                type="text"
                                                id="RUTRET"
                                                name="RUTRET"
                                                value={clienteData.RUTRET}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="PAGCON">Contacto de Cobranza</Label>
                                            <Input
                                                type="text"
                                                id="PAGCON"
                                                name="PAGCON"
                                                value={clienteData.PAGCON}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="PAGDIA">Día Contacto Cobranza</Label>
                                            <Input
                                                type="text"
                                                id="PAGDIA"
                                                name="PAGDIA"
                                                value={clienteData.PAGDIA}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="PAGFON">Teléfono Cobranza</Label>
                                            <Input
                                                type="tel"
                                                id="PAGFON"
                                                name="PAGFON"
                                                value={clienteData.PAGFON}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="PAGMAI">Email Cobranza</Label>
                                            <Input
                                                type="email"
                                                id="PAGMAI"
                                                name="PAGMAI"
                                                value={clienteData.PAGMAI}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup check>
                                            <Label check>
                                                <Input
                                                    type="checkbox"
                                                    id="AUTDVE"
                                                    name="AUTDVE"
                                                    checked={clienteData.AUTDVE}
                                                    readOnly
                                                />
                                                Autorización Venta con DV
                                            </Label>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="USUDVE">Usuario Autoriza DV</Label>
                                            <Input
                                                type="text"
                                                id="USUDVE"
                                                name="USUDVE"
                                                value={clienteData.USUDVE}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="FECADV">Fecha Autorización DV</Label>
                                            <Input
                                                type="datetime-local"
                                                id="FECADV"
                                                name="FECADV"
                                                value={clienteData.FECADV}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="BLOLCH">Bloqueo Cheques</Label>
                                            <Input
                                                type="number"
                                                id="BLOLCH"
                                                name="BLOLCH"
                                                value={clienteData.BLOLCH}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="USUBLH">Usuario Bloqueó</Label>
                                            <Input
                                                type="text"
                                                id="USUBLH"
                                                name="USUBLH"
                                                value={clienteData.USUBLH}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="FECBLH">Fecha Bloqueo</Label>
                                            <Input
                                                type="datetime-local"
                                                id="FECBLH"
                                                name="FECBLH"
                                                value={clienteData.FECBLH}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-4">
                                        <FormGroup check>
                                            <Label check>
                                                <Input
                                                    type="checkbox"
                                                    id="SINEMAIL"
                                                    name="SINEMAIL"
                                                    checked={clienteData.SINEMAIL}
                                                    readOnly
                                                />
                                                Sin Email
                                            </Label>
                                        </FormGroup>
                                    </div>
                                    <div className="col-4">
                                        <FormGroup check>
                                            <Label check>
                                                <Input
                                                    type="checkbox"
                                                    id="SINFECHA"
                                                    name="SINFECHA"
                                                    checked={clienteData.SINFECHA}
                                                    readOnly
                                                />
                                                Sin Fecha Nacimiento
                                            </Label>
                                        </FormGroup>
                                    </div>
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label for="IDSUCURSAL">ID Sucursal</Label>
                                            <Input
                                                type="number"
                                                id="IDSUCURSAL"
                                                name="IDSUCURSAL"
                                                value={clienteData.IDSUCURSAL}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="FLAG_SIGA">Flag SIGA</Label>
                                            <Input
                                                type="number"
                                                id="FLAG_SIGA"
                                                name="FLAG_SIGA"
                                                value={clienteData.FLAG_SIGA}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="FLAG_EXT">Flag Externo</Label>
                                            <Input
                                                type="number"
                                                id="FLAG_EXT"
                                                name="FLAG_EXT"
                                                value={clienteData.FLAG_EXT}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                            </TabPane>
                        </TabContent>
                    </>
                )}
            </ModalBody>
            <ModalFooter>
                <Button type="button" color="light" onClick={handleCancel}>
                    Cerrar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerCliente;